import { useContextLocalization } from "@/app/module/localization/index";
import { Text, TextProps } from "@/base/components/index";
import { useMemo } from "react";

export type LocalizationDateProps = {
  value?: Date;
  dateStyle?: Intl.DateTimeFormatOptions["dateStyle"];
};

export const LocalizationDate = ({
  value,
  dateStyle = "medium",
  hasTextCmp = false,
  ...props
}: LocalizationDateProps & TextProps & { hasTextCmp?: boolean }) => {
  const { currentLang } = useContextLocalization();
  const style = useMemo(() => ({ color: "inherit" }), []);

  if (!value) {
    return null;
  }

  const formattedValue = new Intl.DateTimeFormat(currentLang, {
    dateStyle: dateStyle,
  }).format(value);

  return hasTextCmp ? (
    <Text style={style} {...props}>
      {formattedValue}
    </Text>
  ) : (
    formattedValue
  );
};
